<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <header-component :headerTitle="headerText" />

    <v-container class="px-0" fluid grid-list-lg>
      <v-row class="m-0">
        <v-col v-for="(card, index) in reportCards" :key="index" xs="12" sm="3" md="3">
          <v-card class="rounded-card ma-0" :elevation="4" @click="handleClick(card)" link :to="card.link">
            <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
              <v-col class="p-0 d-flex justify-center align-center">
                <v-icon v-if="card.mdi" size="50" color="#002F9E">{{ card.mdi }}</v-icon>
                <img v-else-if="card.icon" :src="card.icon" width="50" height="50" alt="icon" class="ma-0 mr-2" />
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-3" style="background: #DFDFDF;">
              <v-col class="p-0">
                <div class="text-center" style="cursor: pointer;">
                  <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px; font-weight: 500">
                    {{card.title}}
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import { onMounted } from "vue";
import icon_inward from "@/assets/images/icons/line.png";
import general_settings from "@/assets/images/general_setting.png";
import approval_matrix from "@/assets/images/approval_matrix.png";
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router'
    const store = useStore();
    const router = useRouter();
    const route = useRoute(); 

const headerText = "Configuration Settings";

// All card data in one array
const reportCards = [
  {
    title: "General Settings",
    icon: general_settings,
    action: "",
    link: { name: "GeneralSettings" },
  },
  // {
  //   title: "Approval Matrix",
  //   icon: approval_matrix,
  //   link: { name: "CreateNewApprovalConfig" },
  // },
  {
    title: "Data Validation Values",
    mdi: "mdi-bell-outline",
    link: { name: "DataValidationValues" },
    end_point:"/api/v2/data_validation_profiles",
    file_type:"DataValidationUpload"
  },
  // {
  //   title:"Rule Engine Profile Master",
  //   mdi: "mdi-account-star",
  //   link: {name:"RuleEngineProfileMaster"},
  // },  
  {
    title:"Attribute Configuartion",
    mdi: "mdi-account-settings",
    link: {name:"DataValidationValues"},
  },
  {
    title:"Notification Configuration",
    mdi:"mdi-bell-outline",
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/notification_configurations",
    file_type:"NotificationConfigurationDownload"
  },
  {
    title:"System Masters",
    mdi:"mdi-account-star",
    link:{name:"SystemMasters"},
  },
  {
    title:"Field Nomenclature Mapping",
    mdi:"mdi-text-box-check-outline",
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/front_end_title_masters",
    file_type:"FrontEndTitleMasterUpload"
  },
  {
    title:"Define Channel",
    icon: approval_matrix,
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/channel_masters",
    file_type:"ChannelUpload"
  },
  {
    title:"Return Reason Master",
    icon: approval_matrix,
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/return_reason_masters",
    file_type:"ReturnReasonUpload"
  },
  {
    title:"Liquidation Price",
    mdi:"mdi-account-star",
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/liquidation_price_masters",
    file_type:"LiquidationPriceUpload"
  },
  {
    title:"Depreciation Master",
    mdi:"mdi-text-box-check-outline",
    link:{name:"DataValidationValues"},
    end_point:"/api/v2/depreciation_masters",
    file_type:"DepreciationUpload"
  }
];

function handleClick(card) {
  if (card.action === "downloadTimelineReport") {
    downloadTimelineReport();
  }else if(card.title === "Attribute Configuartion"){
    store.commit("updateTitle", {
      title: card.title
    })
  }else if(card.title === "Data Validation Values"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type   
    })
  }else if(card.title === "Notification Configuration"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }else if(card.title === "Field Nomenclature Mapping"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }else if(card.title === "Define Channel"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }else if(card.title === "Return Reason Master"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }else if(card.title === "Liquidation Price"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }else if(card.title === "Depreciation Master"){
    store.commit("updateTitle", {
      title: card.title,
      end_point: card.end_point,
      file_type: card.file_type
    })
  }
  router.push(card.link);
}
onMounted(() => {
  console.log("Page loaded");
});
</script>

<style scoped>
.rounded-card {
  border-radius: 12px;
  overflow: hidden;
}
.v-card {
  max-width: 97% !important;
}
.v-card-100 {
  max-width: 100% !important;
}
</style>
